import giicaLogo from '@/assets/logo-giica.svg'
import type { FC } from 'react'

export type LogoProps = {
	className?: string
}

export const Logo: FC<LogoProps> = ({ className }) => {
	return (
		<div className={className}>
			<svg viewBox="0 0 219 32" xmlns="http://www.w3.org/2000/svg" className="h-auto w-full">
				<title>GIICA</title>
				<use href={`${giicaLogo.src}#logo-giica`} />
			</svg>
		</div>
	)
}
